var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Location_Normal"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Location_Normal",
    clipPath: "url(#clip-Location_Normal)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Locations",
    transform: "translate(6 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_43",
    "data-name": "Subtraction 43",
    d: "M-1263.96-579.19a.444.444,0,0,1-.338-.154c-.68-.762-6.687-7.55-8.094-11.154a9.221,9.221,0,0,1,1.041-8.541,8.864,8.864,0,0,1,7.383-3.961,8.867,8.867,0,0,1,7.385,3.962,9.225,9.225,0,0,1,1.04,8.54,9.854,9.854,0,0,1-.545,1.158c-.281.517-.632,1.1-1.045,1.744-.245.366-.571.849-.927,1.348-1.42,1.989-3.291,4.311-5.562,6.9A.446.446,0,0,1-1263.96-579.19Zm0-19.6a5.107,5.107,0,0,0-5.1,5.1,5.107,5.107,0,0,0,5.1,5.1,5.107,5.107,0,0,0,5.1-5.1A5.107,5.107,0,0,0-1263.962-598.789Z",
    transform: "translate(1274.04 603.65)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4696",
    "data-name": "Path 4696",
    d: "M19.279,28.166C14.4,28.166,9.2,26.677,9.2,23.92c0-.871.534-2.107,3.039-3.105a.588.588,0,0,1,.771.38.653.653,0,0,1-.356.824c-1.393.554-2.268,1.283-2.268,1.9,0,1.236,3.38,2.963,8.879,2.963s8.879-1.727,8.879-2.963c0-.618-.86-1.347-2.268-1.9a.653.653,0,0,1-.356-.824.588.588,0,0,1,.771-.38c2.52,1,3.039,2.234,3.039,3.105,0,2.757-5.188,4.246-10.065,4.246Z",
    transform: "translate(-9.2 -0.166)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4697",
    "data-name": "Path 4697",
    d: "M21.037,18.407a.722.722,0,0,1-.349-.1.639.639,0,0,1-.19-.887c.206-.317.317-.507.491-.808a.636.636,0,1,1,1.093.65c-.174.317-.3.523-.523.855a.658.658,0,0,1-.539.3Z",
    transform: "translate(-4.044 -1.923)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4698",
    "data-name": "Path 4698",
    d: "M19.129,31.651a1.056,1.056,0,0,1-.784-.353c-1.6-1.8-6.9-7.945-8.235-11.388a9.843,9.843,0,0,1,1.124-9.152A9.485,9.485,0,0,1,19.129,6.55h0a9.466,9.466,0,0,1,7.895,4.208,9.838,9.838,0,0,1,1.124,9.152.594.594,0,0,1-1.109-.427,8.709,8.709,0,0,0-.991-8.048,8.291,8.291,0,0,0-6.9-3.693h0a8.308,8.308,0,0,0-6.9,3.693,8.625,8.625,0,0,0-.991,8.048c.991,2.56,4.716,7.283,7.909,10.9,1.064-1.192,3.489-4.017,5.44-6.753a.594.594,0,0,1,.828-.132.587.587,0,0,1,.133.824c-2.07,2.884-4.627,5.841-5.633,6.974a1.056,1.056,0,0,1-.784.353Z",
    transform: "translate(-9.049 -6.55)",
    fill: "#6f8b8f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationNormal);
export default __webpack_public_path__ + "static/media/Location_Normal.7a757a95f9a54d7ccbc3b048e7439bfc.svg";
export { ForwardRef as ReactComponent };